import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.935 22.363c0 .944-.668 1.71-1.496 1.71H1.497c-.828 0-1.496-.766-1.496-1.71 0-3.42 2.889-6.617 5.84-7.877-1.706-1.206-2.852-3.35-2.852-5.81V6.964c0-3.78 2.68-6.847 5.98-6.847s5.98 3.067 5.98 6.847v1.71c0 2.464-1.149 4.605-2.853 5.812 2.95 1.26 5.838 4.456 5.838 7.877z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.882 22.267h2.975c.633 0 1.144-.586 1.144-1.307 0-2.617-2.21-5.06-4.466-6.023 1.304-.923 2.182-2.561 2.182-4.445v-1.31c0-2.89-2.049-5.236-4.573-5.236q-.471.001-.917.106c.363.883.566 1.87.566 2.91v1.71c0 2.464-.573 4.334-2.075 5.812 2.783.827 5.121 4.391 5.164 7.783"
    }, null, -1)
  ])))
}
export default { render: render }